import api from "@/api/api-v2-config";

export async function getExpenseListAxios(id) {
  return await api.get("expenses/expense?BankId=" + id);
}

export async function postExpenseListAxios(data) {
  return await api.post("expenses/expense", data);
}

export async function updateExpenseListAxios(data) {
  return await api.put("expenses", data);
}

export async function deleteExpenseListAxios(id) {
  return await api.delete("expenses/" + id);
}